import { SkuDTO, SkuPageProp } from '@/types/skuDataBackend';

export function LastViewedSku(
  sku:
    | (Partial<SkuDTO> & Pick<SkuDTO, 'id'>)
    | (Partial<SkuPageProp> & Pick<SkuPageProp, 'id'>)
) {
  const skus = JSON.parse(localStorage.getItem('lastViewedSkus') || '[]');

  if (skus.length) {
    if (skus.length >= 10) {
      skus.shift();
    }

    const foundSku = skus.find((item: SkuDTO) => item.id === sku.id);
    if (foundSku) {
      const index = skus.indexOf(foundSku);
      skus.splice(index, 1);
    }
    skus.push(sku);
  } else {
    skus.push(sku);
  }
  localStorage.setItem('lastViewedSkus', JSON.stringify(skus));
}

export function GetLastViewedSkus() {
  const skus = JSON.parse(localStorage.getItem('lastViewedSkus') || '[]');
  return skus.reverse();
}
